"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StoryLoader = void 0;
const GlobalData_1 = require("./GlobalData");
const SlideObj_1 = require("./SlideObj");
class StoryLoader {
    /** Load story data and labels for the given language ("eng" or "heb"). */
    static load(lang) {
        return __awaiter(this, void 0, void 0, function* () {
            GlobalData_1.GlobalData.currentLang = lang;
            const base = GlobalData_1.GlobalData.getLangPath();
            yield Promise.all([
                StoryLoader.loadStory(`${base}story.json`),
                StoryLoader.loadLabels(`${base}lables.json`),
            ]);
        });
    }
    static loadStory(url) {
        return __awaiter(this, void 0, void 0, function* () {
            const data = yield StoryLoader.fetchJSON(url);
            if (!data)
                return;
            GlobalData_1.GlobalData.pages = [];
            data.items.forEach((item, index) => {
                var _a, _b;
                // Item at index 0 is a jpg title card with no pages/ folder — skip it.
                if (index === 0)
                    return;
                const slide = new SlideObj_1.SlideObj();
                slide.pageNum = index; // pages/<index>/ folder exists for 1-27
                slide.sound = (_a = item.sound.split('/').pop()) !== null && _a !== void 0 ? _a : '';
                slide.caption = item.caption;
                slide.voices = (_b = item.voices) !== null && _b !== void 0 ? _b : {};
                GlobalData_1.GlobalData.pages.push(slide);
            });
            console.log(`StoryLoader: loaded ${GlobalData_1.GlobalData.pages.length} pages`);
        });
    }
    static loadLabels(url) {
        return __awaiter(this, void 0, void 0, function* () {
            const data = yield StoryLoader.fetchJSON(url);
            if (!data)
                return;
            GlobalData_1.GlobalData.labels = data;
        });
    }
    static fetchJSON(url) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const res = yield fetch(url);
                return yield res.json();
            }
            catch (e) {
                console.warn(`StoryLoader: failed to fetch ${url}`, e);
                return null;
            }
        });
    }
}
exports.StoryLoader = StoryLoader;
